import cx from 'classnames';
import { Fragment } from 'react';
import style from './style.scss';
import { uniqueId } from 'lodash';
/* eslint-disable react/prop-types */ // TODO: add props

const WordBank = ({ words, usedIndices }) => {
  if (!words?.length) {
    return null;
  }

  return (
    <section className={cx(style.wordBank)}>
      <label>Word bank:</label>
      {[...words.entries()] // need to sort the indexes too..
        .sort(([indexA, wordA], [indexB, wordB]) => wordA.localeCompare(wordB))
        .map(([originalIndex, word], sortedIndex) => {
          return (
            <Fragment key={uniqueId()}>
              <span
                className={cx({
                  [style.used]:
                    usedIndices && usedIndices.includes(originalIndex),
                })}
              >
                {word}
              </span>
              {sortedIndex < words.length - 1 && <span>{', '}</span>}
            </Fragment>
          );
        })}
    </section>
  );
};

export default WordBank;
